import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  onAllRole,
  onCreateRole,
  onDeleteRole,
  onEditRole,
} from "../../redux/homeAction";

const RoleManagement = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [roles, setRoles] = useState([]);
  const [name, setName] = useState("");
  const [permissions, setPermissions] = useState("");
  const [editId, setEditId] = useState(null);
  const getCreateRole = useSelector((state) => state.home.getCreateRole);
  const getEditRole = useSelector((state) => state.home.getEditRole);
  const getDeleteRole = useSelector((state) => state.home.getDeleteRole);

  useEffect(() => {
    dispatch(onAllRole(setLoader, setRoles));
  }, [getCreateRole, getEditRole, getDeleteRole]);

  // 🔹 Handle Create / Update Role
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const roleData = {
      name,
      permissions: permissions.split(",").map((p) => p.trim()),
    };

    try {
      if (editId) {
        dispatch(onEditRole(setLoader, roleData, editId));
      } else {
        dispatch(onCreateRole(setLoader, roleData));
      }
      setName("");
      setPermissions("");
      setEditId(null);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this role?")) return;

    try {
      dispatch(onDeleteRole(setLoader, id));
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Handle Edit
  const handleEdit = (role) => {
    setName(role.name);
    setPermissions(role.permissions.join(", "));
    setEditId(role._id);
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Role Management</h2>

      {/* Role Form */}
      <form onSubmit={handleSubmit} className="card p-3 mb-4 shadow-sm">
        <div className="mb-3">
          <label className="form-label">Role Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter role name (e.g. admin)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Permissions (comma separated)</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. manage_users, manage_roles"
            value={permissions}
            onChange={(e) => setPermissions(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary mb-3">
          {editId ? "Update Role" : "Create Role"}
        </button>
        {editId && (
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => {
              setName("");
              setPermissions("");
              setEditId(null);
            }}
          >
            Cancel
          </button>
        )}
      </form>

      {/* Role List */}
      <table className="table table-bordered shadow-sm">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Role Name</th>
            <th>Permissions</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {roles.length > 0 ? (
            roles.map((role, index) => (
              <tr key={role._id}>
                <td>{index + 1}</td>
                <td>{role.name}</td>
                <td>{role.permissions.join(", ")}</td>
                <td>
                  <button
                    className="btn btn-sm btn-warning me-2"
                    onClick={() => handleEdit(role)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(role._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No roles found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RoleManagement;
